import { unlinkSync } from "node:fs";
import { LockfileManager } from "../LockfileManager.js";

export interface ResetOptions {
    /** Don't actually delete, just show what would happen */
    dryRun?: boolean;
}

export interface ResetResult {
    /** Whether reset was successful (or would be) */
    success: boolean;
    /** Number of patches that were (or would be) removed */
    patchesRemoved: number;
    /** Whether the lockfile was (or would be) deleted */
    lockfileDeleted: boolean;
    /** True if there was nothing to reset */
    nothingToReset: boolean;
}

export function reset(outputDir: string, options?: ResetOptions): ResetResult {
    const lockManager = new LockfileManager(outputDir);

    if (!lockManager.exists()) {
        return {
            success: true,
            patchesRemoved: 0,
            lockfileDeleted: false,
            nothingToReset: true
        };
    }

    const lock = lockManager.read();
    const patchCount = lock.patches.length;

    if (!options?.dryRun) {
        unlinkSync(lockManager.lockfilePath);
    }

    return {
        success: true,
        patchesRemoved: patchCount,
        lockfileDeleted: true,
        nothingToReset: false
    };
}
